// extracted by mini-css-extract-plugin
export var container = "cta-module--container--MbZ8v";
export var image = "cta-module--image--90+Iw";
export var inner = "cta-module--inner--YSMTJ";
export var title = "cta-module--title--V3IiB";